var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{class:Object.assign({}, _vm.configStyleClasses, _vm.widgetClasses),attrs:{"href":_vm.value.config.url,"target":_vm.value.config.newTab? '_blank' : '_self'},domProps:{"innerHTML":_vm._s(_vm.value.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }